import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { memo as b } from "react";
import { useTranslation as k } from "react-i18next";
import { useFinancialPrograms as T, useCreditChoice as C } from "@perxis-auto/credit-sdk";
import { Col as r, Row as c, Typography as p, Loader as N, FinanceProgram as s } from "@perxis-auto/ui-kit";
import { APP as F } from "../../../shared/config/app.js";
import { APP_EVENTS as L } from "../../../shared/config/events.js";
import { useAppContext as E } from "../../../shared/lib/app/context/appContext.js";
import { eventService as S } from "../../../shared/lib/event/eventService.js";
import { LogoPositionEnum as m } from "./FinancePrograms.types.js";
const B = b(function() {
  const { displayProgramName: v } = E(), { t: i } = k(F.name), { data: t, selected: a, isLoading: u } = T(), {
    actions: { setFinancialProgram: y }
  } = C(), P = (n) => {
    const o = (a == null ? void 0 : a.uid) === n.uid ? null : n;
    S.sendEvent(L.FinanceProgramSelected, {
      program: o
    }), y({ program: o });
  };
  return !u && !(t != null && t.length) ? /* @__PURE__ */ e(r, { className: "perxis-auto-credit-calc-program-empty", children: /* @__PURE__ */ l(c, { gutter: [0, 16], children: [
    /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(p.Title, { headingLevel: 4, className: "perxis-auto-credit-calc-program-empty-title", children: i("programs.empty.title") }) }),
    /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(p.Text, { className: "perxis-auto-credit-calc-program-empty-text", children: i("programs.empty.text") }) })
  ] }) }) : /* @__PURE__ */ l(c, { gutter: [0, "vertical-sky"], children: [
    /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(p.Text, { className: "perxis-auto-credit-calc-program-title", level: "main", children: i("programs.title") }) }),
    /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(N, { spinning: u, size: "large", children: /* @__PURE__ */ e(c, { gutter: [12, "vertical-blue"], children: t == null ? void 0 : t.map((n) => {
      var h, x;
      const o = (h = n.bank) == null ? void 0 : h.name, d = ((x = n.bank) == null ? void 0 : x.logo) || void 0, g = o && d ? m.Top : m.Center, f = [
        {
          id: "1",
          label: i("programs.bank"),
          value: o,
          logo: g === m.Center ? d : void 0
        },
        {
          id: "2",
          label: i("programs.interestRate"),
          value: `${n.condition.rate}`
        }
      ];
      return /* @__PURE__ */ e(r, { xs: 24, md: 12, lg: 12, sm: 12, xl: 12, xxl: 12, children: /* @__PURE__ */ e(
        s,
        {
          onClick: () => P(n),
          isSelected: n.uid === (a == null ? void 0 : a.uid),
          children: /* @__PURE__ */ l(c, { gutter: [0, "vertical-sky"], children: [
            /* @__PURE__ */ e(r, { span: 24 }),
            /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ l(c, { gutter: [0, "vertical-green"], children: [
              /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(s.Image, { src: g === m.Top ? d : void 0 }) }),
              /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ l(c, { gutter: [0, "vertical-sky"], children: [
                v && /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(s.Title, { title: n.name }) }),
                /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(s.Table, { items: f }) }),
                /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(
                  s.Price,
                  {
                    label: i("programs.price"),
                    text: i("currency", {
                      value: n.payment,
                      currency: n.currency
                    })
                  }
                ) })
              ] }) })
            ] }) })
          ] })
        }
      ) }, n.uid);
    }) }) }) })
  ] });
});
export {
  B as FinancePrograms
};
